import { IexQuote } from "$gql/types.gen";
import {
  customCurrencyFormat,
  formatCurrency,
  formatPercent,
} from "@tiicker/util/lib/formats";
import React from "react";
import styles from "./QuoteInfo.module.scss";
import * as DateIso from "@tiicker/util/lib/date-iso";
import classNames from "classnames";
import Button from "components/core/Button/Button";

type Props = {
  quote: IexQuote;
  large?: boolean;
  inline?: boolean;
  button?: boolean;
  openTrade: () => void;
};

const QuoteInfo = (props: Props) => {
  const wentUp = (props.quote.change || 0) >= 0;
  const latestPrice = props.quote?.latestPrice || 0;
  const change = props.quote?.change || 0;
  const changePercent = props.quote?.changePercent || 0;
  const currency = props.quote?.currency || "USD";

  return (
    <>
      <div
        className={classNames(styles.priceContainer, {
          [styles.inline]: props.inline,
        })}
      >
        <h4
          className={classNames(styles.stockPrice, {
            [styles.largeStockPrice]: props.large,
          })}
        >
          {customCurrencyFormat(latestPrice)}{" "}
          {currency &&
            currency.toUpperCase() !== "USD" &&
            `${currency.toUpperCase()}`}
        </h4>
        <span className={styles.stockPrice}>
          <span
            className={classNames(
              styles.changePercent,
              wentUp ? styles.up : styles.down,
              { [styles.largeChangePercent]: props.large }
            )}
          >
            {customCurrencyFormat(props.quote.change || 0)} (
            {isFinite(props.quote.changePercent || 0)
              ? formatPercent(props.quote.changePercent || 0)
              : "—%"}
            )
          </span>
          {props.quote.latestDate && (
            <p
              className={classNames(styles.dayLabel, {
                [styles.largeDayLabel]: props.large,
              })}
            >
              {DateIso.toMarketDate(props.quote.latestDate)}
            </p>
          )}
        </span>
      </div>
      <Button
        arrow={props.inline ? false : true}
        type={props.button ? "primary" : "inline"}
        className={classNames({ [styles.fullWidthButton]: props.inline })}
        onClick={props.openTrade}
      >
        Trade
      </Button>
    </>
  );
};

export default QuoteInfo;
